/**
 *  All api related to department
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchCommerceChannel(options = {}) {
  const { code, ...params } = options
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchCommerceChannel',
    () => source.cancel('fetchCommerceChannel: Operation cancelled by user')
  )
  cancelRequest.add(
    `fetchCommerceChannel.${code}`,
    () => source.cancel(`fetchCommerceChannel.${code}: Operation cancelled by user`)
  )

  return OmnitechApi
    .request({
      endpoint: `commerce_channels/by_code/${code}`,
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ cacheChecksum, data }) => ({
      commerceChannel: data.commerceChannel,
      cacheChecksum: _.get(cacheChecksum, 'commerceChannelsValue'),
    }))
}
